import React from 'react';
import { Paper, Typography, Box, Skeleton } from '@mui/material';

/**
 * StatCard Component
 * Displays a statistic with title, value, and optional icon
 */
const StatCard = ({ 
  title, 
  value, 
  icon, 
  color = '#1976d2', 
  loading = false,
  currency = false,
  formatOptions = {}
}) => {
  // Format value if needed
  const formattedValue = () => {
    if (loading) {
      return <Skeleton variant="text" width="60%" height={60} />;
    }
    
    if (currency) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0,
        ...formatOptions
      }).format(value);
    }
    
    return value.toLocaleString('en-US');
  };
  
  return (
    <Paper 
      elevation={2} 
      sx={{ 
        p: 2, 
        display: 'flex', 
        flexDirection: 'column', 
        height: 140,
        backgroundColor: color === '#1976d2' ? '#f9f9ff' : 
                        color === '#f44336' ? '#fff9f9' : 
                        color === '#4caf50' ? '#f9fff9' : '#ffffff',
        borderLeft: `4px solid ${color}`
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h6" color="text.secondary">
          {loading ? <Skeleton width="80%" /> : title}
        </Typography>
        {icon && (
          <Box sx={{ color: `${color}99` }}>
            {icon}
          </Box>
        )}
      </Box>
      <Typography 
        variant="h3" 
        component="div" 
        sx={{ 
          mt: 'auto', 
          fontWeight: 'bold', 
          color: color === '#ffffff' ? 'text.primary' : color
        }}
      >
        {formattedValue()}
      </Typography>
    </Paper>
  );
};

export default StatCard;